import { combineReducers } from 'redux';
import { tasksReducer } from './tasks';
import { materialReducer } from './materials';
import { labourReducer } from './labours';
import { defectReducer } from './defects';
import { taskHistoryReducer } from './taskHistory';
import { productHistoryReducer } from './productHistory';
import { warehouseProductReducer } from './warehouseProduct';
import { alertReducer } from './alert';

const rootReducer = combineReducers({
  tasks1: tasksReducer,
  materialReducer,
  labourReducer,
  defectReducer,
  taskHistoryReducer,
  productHistoryReducer,
  warehouseProductReducer,
  alertReducer,
});

export default rootReducer;
